import {initElements} from "../define/shared"
import StickySidebar from 'sticky-sidebar';

export default function initCategoriesSidebar() {
    initElements(".categoriesSidebar", sidebar => {
        const categories = [].slice.apply(sidebar.querySelectorAll('.category'))

        categories.forEach(cat => {
            const arrow = cat.querySelector('.openProducts')

            arrow.addEventListener('click', () => {
                cat.classList.toggle('is--open')
            })
        })
    })
    initElements(".sidebar__inner", sidebar__inner => {

        new StickySidebar(sidebar__inner, {
            topSpacing: 40,
            bottomSpacing: 40,
            containerSelector: '.sidebar',
            innerWrapperSelector: '.productBanner'
        });
    })
}
